import { Role } from '@okletsplay/core';
import { sessionSelector } from 'app/store/session/selectors';
import { useCallback } from 'react';
import { useSelector } from 'react-redux';

import { hasAllRoles as hasAllRolesUtil, hasAnyRole as hasAnyRoleUtil } from '../utils';

export interface UseRolesHook {
  userRoles: Role[];
  hasAllRoles: (roles: Role[]) => boolean;
  hasAnyRole: (roles: Role[]) => boolean;
}

export const useRoles = (): UseRolesHook => {
  const userRoles = useSelector(sessionSelector.roles);

  const hasAllRoles = useCallback(
    (roles: Role[]) => hasAllRolesUtil(roles, userRoles),
    [userRoles]
  );
  const hasAnyRole = useCallback((roles: Role[]) => hasAnyRoleUtil(roles, userRoles), [userRoles]);

  return { userRoles, hasAllRoles, hasAnyRole };
};
